<ng-container *transloco="let t">
  <ld-base-modal
    [title]="t('modalsDeleteAssetsTitle')"
    [size]="'medium'"
    [isLoading]="isLoading()"
    [ariaLabelledBy]="'delete-assets-modal-title'"
    (closeModal)="onCancel()"
  >
    <div modal-content>
      @if (borrowerName()) {
        <p
          class="font-dm text-sm text-ld-neutral-600 mb-4"
          [innerHTML]="t('modalsDeleteAssetsMessageWithBorrower', { name: borrowerName() })"
        ></p>
      } @else {
        <p class="font-dm text-sm text-ld-neutral-600 mb-4">{{ t('modalsDeleteAssetsMessage') }}</p>
      }

      <div class="p-4 bg-amber-50 border border-amber-200 rounded-xl">
        <div class="flex items-start gap-3">
          <mat-icon class="text-amber-600 shrink-0 mt-0.5">warning</mat-icon>
          <div>
            <p class="font-dm text-sm text-amber-800">
              {{ t('modalsDeleteAssetsWarning') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div modal-footer>
      <button
        id="delete-assets-cancel-btn"
        type="button"
        class="btn-outline-ld-purple"
        [disabled]="isLoading()"
        (click)="onCancel()"
      >
        {{ t('commonButtonsCancel') }}
      </button>
      <button
        id="delete-assets-confirm-btn"
        type="button"
        class="btn-solid-red"
        [disabled]="isLoading()"
        (click)="onConfirm()"
      >
        @if (isLoading()) {
          <mat-spinner diameter="16" class="w-4! h-4! [&_circle]:stroke-white!"></mat-spinner>
        }
        {{ t('modalsDeleteAssetsConfirmButton') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
